import React from "react";
import { cn } from "../../lib/utils";
import { audioSupported } from "../../lib/synthLab";
import { KEY_LAYOUT } from "./useSynthInput";

const CAN_PLAY = audioSupported();
const WHITE_KEYS = KEY_LAYOUT.filter((k) => !k.black);

// Tap-or-hold playable keyboard. Presentational: it calls the shared
// press/release and highlights notes in the `active` set (so MIDI / typed
// notes light up too). Holds use startNote/stop for true ADSR feel.
const Keyboard = ({ press, release, active }) => {
  if (!CAN_PLAY) return null;

  const whiteW = 100 / WHITE_KEYS.length;
  return (
    <div className="select-none">
      <div className="relative h-32 w-full" style={{ touchAction: "none" }}>
        {/* white keys */}
        <div className="flex h-full w-full">
          {WHITE_KEYS.map((k) => (
            <button
              key={k.midi}
              type="button"
              onPointerDown={(e) => {
                e.preventDefault();
                e.currentTarget.setPointerCapture(e.pointerId);
                press(k.midi);
              }}
              onPointerUp={() => release(k.midi)}
              onPointerCancel={() => release(k.midi)}
              onPointerLeave={(e) => e.buttons && release(k.midi)}
              className={cn(
                "relative flex h-full flex-1 items-end justify-center rounded-b-md border border-border pb-1 text-[0.6rem] text-slate-400",
                active.has(k.midi) ? "bg-primary/30" : "bg-white active:bg-primary/20"
              )}
            >
              {k.kb.toUpperCase()}
            </button>
          ))}
        </div>
        {/* black keys */}
        {KEY_LAYOUT.filter((k) => k.black).map((k) => {
          const whitesBefore = KEY_LAYOUT.filter((x) => !x.black && x.midi < k.midi).length;
          return (
            <button
              key={k.midi}
              type="button"
              onPointerDown={(e) => {
                e.preventDefault();
                e.currentTarget.setPointerCapture(e.pointerId);
                press(k.midi);
              }}
              onPointerUp={() => release(k.midi)}
              onPointerCancel={() => release(k.midi)}
              onPointerLeave={(e) => e.buttons && release(k.midi)}
              className={cn(
                "absolute top-0 z-10 flex h-20 items-end justify-center rounded-b-md border border-slate-800 pb-1 text-[0.55rem] text-slate-400",
                active.has(k.midi) ? "bg-primary" : "bg-slate-900 active:bg-primary"
              )}
              style={{ width: `${whiteW * 0.62}%`, left: `${whitesBefore * whiteW - whiteW * 0.31}%` }}
            >
              {k.kb.toUpperCase()}
            </button>
          );
        })}
      </div>
      <p className="mt-2 text-center text-xs text-muted-foreground">
        Tap the keys, or use your keyboard — sounds your current patch.
      </p>
    </div>
  );
};

export default Keyboard;
